import React, { useState, useMemo } from "react";
import {
  formatContent,
  extractImagesFromContent,
} from "../utils/formatContent";
import ImageModal from "./ImageModal";

const FormattedContent = ({ content, language = "en", className = "" }) => {
  const [selectedImage, setSelectedImage] = useState(null);

  // Format the content with enhanced styling
  const formattedContent = useMemo(() => {
    return formatContent(content, language);
  }, [content, language]);

  // Extract images for potential use
  const images = useMemo(() => {
    return extractImagesFromContent(content);
  }, [content]);

  // Handle image clicks
  const handleImageClick = (e) => {
    if (e.target.tagName === "IMG") {
      const src = e.target.src;
      const alt = e.target.alt || "";
      setSelectedImage({ src, alt });
    }
  };

  // Close image modal
  const closeImageModal = () => {
    setSelectedImage(null);
  };

  if (!content) return null;

  return (
    <>
      <div
        className={`wysiwyg-content ${className}`}
        dangerouslySetInnerHTML={{ __html: formattedContent }}
        onClick={handleImageClick}
      />

      {/* Image Modal */}
      <ImageModal
        isOpen={!!selectedImage}
        imageSrc={selectedImage?.src}
        imageAlt={selectedImage?.alt}
        onClose={closeImageModal}
      />
    </>
  );
};

export default FormattedContent;
